import React, { Component } from 'react';

import Logo from '../../../images/logo.png';

import ReactToPrint from "react-to-print";
import { FiPrinter, FiX, FiMail } from 'react-icons/fi';
import QRCode from 'qrcode';

class ComponentToPrint extends React.Component {

  state = { printing: false }

  renderViaContent(data, cliente, qrDataUrl) {
    const phoneEnvia = data.cliente?.telefones?.[0] || cliente?.telefones?.[0] || "";
    return (
      <>
        <div className="_header">
          <img src={Logo} alt="JuliaFloresRJ" />
          <div className="_cardInfo">
            <span>Pedido #{data.simpleId || data.entrega.simpleId}</span>
            { data.entrega.shippingMessageSelect ?
              (<span className="_card"><FiMail /> Cartão <span className="_bold">Adicionado</span></span>) :
              (<span className="_card not"><FiMail /> Cartão <span className="_bold">Não Adicionado</span></span>)
            }
          </div>
        </div>

        { qrDataUrl ? (
          <div className="_items OrderPrint-withQr">
            <div className="OrderPrint-detailStack">
              <div className="_item">
                <span className="title">Data da entrega:</span>
                <span className="text">{data.entrega.shippingDate}</span>
              </div>
              <div className="_item">
                <span className="title">Periodo:</span>
                <span className="text">{data.entrega.shippingPeriod}</span>
              </div>
              <div className="_item">
                <span className="title">Quem envia:</span>
                <span className="text">{data.entrega.shippingSender}  - {phoneEnvia}</span>
              </div>
              <div className="_item">
                <span className="title">Quem Recebe:</span>
                <span className="text">{data.entrega.shippingRecipient}</span>
              </div>
            </div>
            <div className="OrderPrint-qrCol">
              <div className="OrderPrint-qrRow OrderPrint-qrRow--sideColumn">
                <img src={qrDataUrl} alt="" className="OrderPrint-qrImg" />
                <div>
                  <span className="OrderPrint-qrTitle">Entrega - Atribuir motorista e lote</span>
                  <span className="OrderPrint-qrHint">Escaneie com a câmera do celular</span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="_items">
              <div className="_item">
                <span className="title">Data da entrega:</span>
                <span className="text">{data.entrega.shippingDate}</span>
              </div>
              <div className="_item">
                <span className="title">Periodo:</span>
                <span className="text">{data.entrega.shippingPeriod}</span>
              </div>
            </div>
            <div className="_items">
              <div className="_item">
                <span className="title">Quem envia:</span>
                <span className="text">{data.entrega.shippingSender}  - {phoneEnvia}</span>
              </div>
              <div className="_item">
                <span className="title">Quem Recebe:</span>
                <span className="text">{data.entrega.shippingRecipient}</span>
              </div>
            </div>
          </>
        ) }

        <div className="_item">
          <span className="title">Endereço da entrega:</span>
          <span className="text">{data.entrega.endereco.local}, n°{data.entrega.endereco.numero} - {data.entrega.endereco.bairro}</span>
          { data.entrega.endereco.complemento && (<span className="text">Complemento: {data.entrega.endereco.complemento}</span>)}
        </div>

        <div className="_item">
          <span className="title">Produtos:</span>
          { (data.carrinho || data.pedido.carrinho).map((item, idx) => {
            const produto = item.produto && typeof item.produto === "object" ? item.produto : null;
            const upsell = item.upsell && typeof item.upsell === "object" ? item.upsell : null;
            const titulo = upsell?.titulo || produto?.titulo || (item.upsell || item.produto ? "Produto indisponível" : "Upsell");

            return (
              <div key={idx}>
                <span className="text">{item.quantidade} </span>
                <span className="text">{titulo}</span>
              </div>
            );
          }) }
        </div>

        { data.observation && (
          <div className="_item">
            <span className="title">Observação:</span>
            <span className="text">{ data.observation }</span>
          </div>
        ) }
      </>
    );
  }

  render() {
    const { data, cliente, qrDataUrl } = this.props;
		if(!data) return null;

    return (
      <div className="OrderPrint_wrapper">
        <div className="column">
          { this.renderViaContent(data, cliente, qrDataUrl) }
        </div>

        <div className="column">
          { this.renderViaContent(data, cliente, qrDataUrl) }
        </div>
      </div>
    )
  }
}

class OrderPrint extends Component {

	state = { qrDataUrl: null }

	componentDidMount(){
		this.loadQr();
	}

	componentDidUpdate(prevProps){
		const id = this.props.data && this.props.data.entrega && this.props.data.entrega._id;
		const prevId = prevProps.data && prevProps.data.entrega && prevProps.data.entrega._id;
		if(id !== prevId){
			this.loadQr();
		}
	}

	loadQr = () => {
		const { data } = this.props;
		if(!data || !data.entrega || !data.entrega._id){
			this.setState({ qrDataUrl: null });
			return;
		}
		const id = String(data.entrega._id);
		const base = `${window.location.origin}${window.location.pathname}`.replace(/\/$/, '');
		const url = `${base}#/assign-delivery/${id}`;
		QRCode.toDataURL(url, { width: 140, margin: 1, errorCorrectionLevel: 'M' })
			.then((qrDataUrl) => this.setState({ qrDataUrl }))
			.catch(() => this.setState({ qrDataUrl: null }));
	}

  render(){
    return (
      <>
        <div className="OrderPrint">
          <ComponentToPrint data={this.props.data} cliente={this.props.cliente} qrDataUrl={this.state.qrDataUrl} ref={el => (this.componentRef = el)} />
          <div className="actions">
            <ReactToPrint
              trigger={() => <button className="btntool btntool-success"><FiPrinter /></button>}
              content={() => this.componentRef}
            />
            <button onClick={this.props.onClick} className="btntool btntool-danger"><FiX /></button>
          </div>
        </div>
      </>
    )
	}
}

export default OrderPrint;
